import * as React from "react";
import ExportErrorPage from "export/ExportErrorPage";
import ErrorBoundary from "components/errors/ErrorBoundary";
const ExportErrorBoundary = ({ children }) => /* @__PURE__ */ React.createElement(ErrorBoundary, { FallbackComponent: ExportErrorPage }, children);
export default ExportErrorBoundary;
